import API from "../../helpers/API";
import {
  SET_ALL_CATEGORIES_LIST,
  SET_ALL_SUBCATEGORIES_LIST,
  SHOW_LOADER,
  HIDE_LOADER,
  SET_ALL_UNAPPROVED_CUTOFF_LIST,
  SET_UNAPPROVAL_CUTOFF_PAGE_NO_COUNTER,
  GET_CUT_OFF_LIST,
  SET_ALL_INTERVIEW_ATTENDEE_LIST,
  SET_ALL_INTERVIEW_ABSENTEE_LIST,
  SET_QUALIFYING_CANDIDATES_LIST,
  SET_RESERVATION_DATA,
  SET_INTERVIEW_QUALIFIED_CANDIDATE_DATA,
  SET_VENUE_LIST,
  GET_INTERVIEW_LIST,
  SET_SLAB_REPORT_DATA,
  SET_CUTOFF_CRITERIA,
  SET_INTERVIEW_LIST,
  SET_INTERVIEW_POST_PREFERENCE_LIST,
  GET_ALL_ALLOTMENT_CHART_DATA,
  SET_ALL_DUPLICATE_CODE_DATA,
  SET_ALL_UNAPPROVED_INTERVIEW_CRITERIA_LIST,
  SET_UNAPPROVAL_INTERVIEW_CRITERIA_PAGE_NO_COUNTER,
  SET_ALL_UNAPPROVED_RECOMMENDATION_CRITERIA_LIST,
  SET_UNAPPROVAL_RECOMMENDATION_CRITERIA_PAGE_NO_COUNTER,
  SET_RECOMMENDATION_CUTOFF_LIST,
  GET_INTERVIEW_QUALIFIED_CANDIDATE,
  SET_RECOMMENDATION_VIGATVARI_DATA,
  SET_INTERVIEW_SCHEDULE,
  SET_REVISED_INTERVIEW_SCHEDULE,
  SET_INTERVIEW_LETTER,
  GET_STAGE_LIST,
  GET_RECOMMENDATION_CRITERIA_VIEW
} from "../../common/constants/ActionTypes";
import {
  GET_ALL_CATEGORIES,
  GET_ALL_SUBCATEGORIES,
  SAVE_QUALIFICATION_CUTOFF_DATA,
  GETRULESAPPROVALACTION,
  ENTITY_APPROVAL,
  GETCUTOFFLIST,
  GET_INTERVIEW_ATTENDEE_LIST,
  GET_INTERVIEW_ABSENTEE_LIST,
  GETQUALIFYINGLIST,
  GET_RESERVATION_DATA,
  GET_INTERVIEW_QUALIFIED_CANDIDATE_DATA,
  GET_INTERVIEW_QUALIFIED_CANDIDATE_LIST,
  GET_VENUE_LIST,
  GETINTERVIEWLIST,
  SAVEQUALIFICATIONMULTIPLE,
  SEAT_MATRIX_LOCK_UNLOCK,
  CALCULATE_CUTOFF,
  SAVE_CREATE_INTERVIEW_LETTER,
  GET_GENERAL_SLAB_REPORT,
  GET_CUTOFF_CRITERA,
  GET_UNLOCK_CUTOFF,
  GET_NEW_INTERVIEW_LIST,
  INTERVIEW_POST_PREFERENCE,
  ALLOTMENT_CHART_REPORT,
  GET_DUPLICATE_CODE_NO,
  GET_INTERVIEW_CRITERIA,
  GET_INTERVIEW_CRITERIA_APPROVAL_ENTITY,
  GET_RECOMMENDATION_CRITERIA,
  GET_RECOMMENDATION_CRITERIA_APPROVAL_ENTITY,
  GET_RECOMMENDATION_CUTOFF,
  GET_RECOMMENDATION_REPORTS_QUALIFIED,
  GET_INTERVIEW_REPORTS_QUALIFIED,
  GET_REPORTS_QUALIFIED_CANDIDATE,
  GET_RECOMMENDATION_CALCULATE_QUALIFIED,
  GET_RECOMMENDATION_VIGATVARI,
  GET_INTERVIEW_SCHEDULE,
  GET_REVISED_INTERVIEW_SCHEDULE,
  UPDATE_INTERVIEW_LETTER,
  GET_INTERVIEW_LETTER
} from "../../common/constants/endpoints";
import label from "../labels/interviewProcess_en.json";
import { handleError, handleResponseMessage } from "../../common/actions/commonActions";
import PdfFileDownload from "../../common/components/PdfFileDownload";
import { toastr } from "react-redux-toastr";
import { getObjectiveStatus } from "../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";

export const showLoader = () => {
  return (dispatch) => {
    dispatch({
      type: SHOW_LOADER,
    });
  };
};

export const hideLoader = () => {
  return (dispatch) => {
    dispatch({
      type: HIDE_LOADER,
    });
  };
};

export const getReservationData = (examId, Stage, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_RESERVATION_DATA}?examid=${examId}&stage=${Stage}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        // handleResponseMessage(response);
        dispatch({
          payload: response.data,
          type: SET_RESERVATION_DATA,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: [],
        type: SET_RESERVATION_DATA,
      });
      handleError(error);
    }
  };
};

// export const getCutOffCriteria = (examId, setPrintFlag) => {
//   return async (dispatch) => {
//     dispatch(showLoader());
//     const session = JSON.parse(sessionStorage.getItem("session"));
//     let token = session.jwtResponse && session.jwtResponse.token;
//     try {
//       let response = await API.get(`${GET_CUTOFF_CRITERA}?examid=${examId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (response) {
//         dispatch({
//           payload: response.data,
//           type: SET_CUTOFF_CRITERIA,
//         });
//       }
//       dispatch(hideLoader());
//     } catch (error) {
//       dispatch(hideLoader());
//       dispatch({
//         payload: [],
//         type: SET_CUTOFF_CRITERIA,
//       });
//       setPrintFlag(true);
//       handleError(error);
//     }
//   };
// };
export const getCutOffCriteria = (examId, setPrintFlag, setConfirmClicked) => {
  return async (dispatch) => {
    dispatch(showLoader());

    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session.jwtResponse?.token;

    try {
      const response = await API.get(
        `${GET_CUTOFF_CRITERA}?examid=${examId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response?.data) {
        dispatch({
          type: SET_CUTOFF_CRITERIA,
          payload: response.data,
        });

        // Enable Print
        setPrintFlag(false);
        setConfirmClicked(true);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());

      dispatch({
        type: SET_CUTOFF_CRITERIA,
        payload: [],
      });

      setPrintFlag(true);
      setConfirmClicked(false);

      handleError(error);
    }
  };
};

export const getAdminCategory = () => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      let response = await API.get(GET_ALL_CATEGORIES, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALL_CATEGORIES_LIST,
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAdminSubCategory = () => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      let response = await API.get(GET_ALL_SUBCATEGORIES, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALL_SUBCATEGORIES_LIST,
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};
export const saveQualificationCutOff = (
  examid,
  postCriteriaIds,
  data,
  setRequestedData,
  setSelectedData,
  setSelectedSubCategory
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  const token = session.jwtResponse && session.jwtResponse.token;

  return async (dispatch) => {
    dispatch(showLoader());

    const query = postCriteriaIds
      .map((id) => `postCriteriaIds=${id}`)
      .join("&");

    try {
      const response = await API.post(
        `${SAVE_QUALIFICATION_CUTOFF_DATA}?examid=${examid}&${query}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response) {
        handleResponseMessage(response);
        setRequestedData([]);
        setSelectedData([]);
        setSelectedSubCategory("");
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const patchQualificationCutOff = (
  examid,
  postCriteriaIds,
  data,
  setRequestedData,
  setSelectedData,
  setSelectedSubCategory
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  const token = session.jwtResponse && session.jwtResponse.token;

  return async (dispatch) => {
    dispatch(showLoader());

    const query = postCriteriaIds
      .map((id) => `postCriteriaIds=${id}`)
      .join("&");

    try {
      const response = await API.patch(
        `${SAVE_QUALIFICATION_CUTOFF_DATA}?examid=${examid}&${query}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response) {
        handleResponseMessage(response);
        setRequestedData([]);
        setSelectedData([]);
        setSelectedSubCategory("");
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};
// export const saveQualificationCutOff = (
//   examid,
//   postCriteriaIds,
//   data,
//   setRequestedData,
//   setSelectedData,
//   setSelectedSubCategory
// ) => {
//   const session = JSON.parse(sessionStorage.getItem("session"));
//   let token = session.jwtResponse && session.jwtResponse.token;
//   return async (dispatch) => {
//     dispatch(showLoader());
//     const query = postCriteriaIds
//       .map(id => `postCriteriaIds=${id}`)
//       .join("&");
//     try {
//       let response = await API.post(
//         `${SAVE_QUALIFICATION_CUTOFF_DATA}?examid=${examid}${query}`,
//         data,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (response) {
//         handleResponseMessage(response);
//         // let msg =
//         //   response && response.data ? response.data.message : response.message;
//         setRequestedData([]);
//         setSelectedData([]);
//         setSelectedSubCategory("");
//         // toastr.success(msg);
//       }

//       dispatch(hideLoader());
//     } catch (error) {
//       dispatch(hideLoader());
//       handleError(error);
//     }
//   };
// };

// export const patchQualificationCutOff = (
//   examid,
//   postCriteriaIds,
//   data,
//   setRequestedData,
//   setSelectedData,
//   setSelectedSubCategory
// ) => {
//   const session = JSON.parse(sessionStorage.getItem("session"));
//   let token = session.jwtResponse && session.jwtResponse.token;
//   return async (dispatch) => {
//     dispatch(showLoader());

//     const query = postCriteriaIds
//       .map(id => `postCriteriaIds=${id}`)
//       .join("&");
//     try {
//       let response = await API.patch(
//         `${SAVE_QUALIFICATION_CUTOFF_DATA}?examid=${examid}&${query}`,
//         data,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (response) {
//         handleResponseMessage(response);
//         // let msg =
//         //   response && response.data ? response.data.message : response.message;
//         setRequestedData([]);
//         setSelectedData([]);
//         setSelectedSubCategory("");
//         // toastr.success(msg);
//       }

//       dispatch(hideLoader());
//     } catch (error) {
//       dispatch(hideLoader());
//       handleError(error);
//     }
//   };
// };

export const getAllUnApproveCutOffListPagination = (pageNumber, rowPerPage) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GETRULESAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=qualification_criteria`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_ALL_UNAPPROVED_CUTOFF_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_ALL_UNAPPROVED_CUTOFF_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_CUTOFF_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_ALL_UNAPPROVED_CUTOFF_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const approvalEntityCutOffRequest = (requestData, setShowModal) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllUnApproveCutOffListPagination(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const getInterviewQualifiedCandidateData = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_INTERVIEW_QUALIFIED_CANDIDATE_LIST}/${examId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_INTERVIEW_QUALIFIED_CANDIDATE_DATA,
        });
        handleResponseMessage(response);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: [],
        type: SET_INTERVIEW_QUALIFIED_CANDIDATE_DATA,
      });
      handleError(error);
    }
  };
};

export const getVenueList = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_VENUE_LIST}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_VENUE_LIST,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: [],
        type: SET_VENUE_LIST,
      });
      handleError(error);
    }
  };
};
export const getCutOffListByExamId = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GETCUTOFFLIST}/?examid=${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        handleResponseMessage(response);
        dispatch({
          payload: response.data,
          type: GET_CUT_OFF_LIST,
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getInterviewScheduleListByExamId = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GETINTERVIEWLIST}/${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_INTERVIEW_LIST,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getInterAttendeeList = (examId) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_INTERVIEW_ATTENDEE_LIST}?examid=${examId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          type: SET_ALL_INTERVIEW_ATTENDEE_LIST,
          payload: response.data,
        });
      }
    } catch (error) {
      handleError(error);
    }
  };
};

export const getInterAbsenteeList = (examId) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_INTERVIEW_ABSENTEE_LIST}?examid=${examId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          type: SET_ALL_INTERVIEW_ABSENTEE_LIST,
          payload: response.data,
        });
      }
    } catch (error) {
      handleError(error);
    }
  };
};

export const printInterviewAttendeeList = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      const divId = "resultAttendeeList";
      const constants = {
        PDFX: 50,
        PDFY: 50,
        CDCPDFWIDTH: 900,
        CDCPDFHEIGHT: 1480,
      };
      const size = [1000, 2400];
      const file_name = `Attendee_List_${examId}`;

      PdfFileDownload(divId, constants, size, file_name);

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const printInterviewAbsenteeList = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      const divId = "resultAbsenteeList";
      const constants = {
        PDFX: 10,
        PDFY: 10,
        CDCPDFWIDTH: 980,
        CDCPDFHEIGHT: 1480,
      };
      const size = [1000, 2400];
      const file_name = `Absentee_List_${examId}`;

      PdfFileDownload(divId, constants, size, file_name);

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getQualifyingCandidatesList = (examId) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(`${GETQUALIFYINGLIST}?examid=${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        handleResponseMessage(response);
        dispatch({
          type: SET_QUALIFYING_CANDIDATES_LIST,
          payload: response.data,
        });
      }
    } catch (error) {
      handleError(error);
    }
  };
};

export const SeatMatrixLockUnlock = (
  examid,
  status,
  lock,
  setUnlock,
  getReservedSeats
) => {
  return async (dispatch) => {

    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(
        `${SEAT_MATRIX_LOCK_UNLOCK}?examid=${examid}&status=${status}&lock=${lock}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // setShowModal(false);
      // dispatch(getAllUnApproveRulesListPagination(0, 10));
      let successMessage =
        response && response.data ? response.data : response.message;
      toastr.success(successMessage);
      setUnlock(true);
      if (status == "interviewCriteria" || status == "recommendationcriteria" || status == "interviewqualification" || status == "recommendationqualification" || status == "seatmatrix" || status == "multiple") {
        dispatch(getObjectiveStatus(examid))

      } else {
        dispatch(getReservedSeats(examid));

      }
    } catch (error) {
      handleError(error);
    }
  };
};

export const printQualifyingCandidatesList = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      const divId = "qualifyingCandidatesList";
      const constants = {
        PDFX: 50,
        PDFY: 50,
        CDCPDFWIDTH: 900,
        CDCPDFHEIGHT: 1480,
      };
      const size = [1000, 2400];
      const file_name = `Qualifying_Candidates_List_${examId}`;

      PdfFileDownload(divId, constants, size, file_name);

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const printInterviewSchedulesData = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      const divId = "AnswerKey";
      const constants = {
        PDFX: 50,
        PDFY: 50,
        CDCPDFWIDTH: 900,
        CDCPDFHEIGHT: 1480,
      };
      const size = [1000, 2400];
      const file_name = `Interview_Letters_Schedule_${examId}`;

      PdfFileDownload(divId, constants, size, file_name);

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const saveQualificationMultiple = (
  examid,
  multipleVal,
  stage,
  setSelectedAdvertNo,
  examList,
  setSelectedExam,

) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      let response = await API.get(
        `${SAVEQUALIFICATIONMULTIPLE}?examid=${examid}&multiple=${multipleVal}&stage=${stage}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        let msg = response?.data;
        toastr.success(msg);
        examList.length = 0;
        dispatch(getReservationData(examid));
        setSelectedAdvertNo("");
        setSelectedExam("");
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const calculateCutoff = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${CALCULATE_CUTOFF}?examid=${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      let successMessage =
        response && response.data && response.data ? response.data.message : "";
      toastr.success(successMessage);
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_RESERVATION_DATA,
        });
      }
      dispatch(hideLoader());
    } catch (error) {

      dispatch(hideLoader());
      dispatch({
        payload: [],
        type: SET_RESERVATION_DATA,
      });
      handleError(error);
    }
  };
};

export const saveAddScheduleData = (examid, data, date) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  let formData = new FormData();
  if (data) {
    formData.append("file", data.file);
    formData.append("type", data.type);
    // if (date) {
    //   formData.append("updateDataFrom", date);
    // }
  }

  let headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      let response = await API.post(
        `${SAVE_CREATE_INTERVIEW_LETTER}?examid=${examid}`,
        formData,
        {
          headers: headers,
        }
      );

      if (response) {
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const updateScheduleData = (examid, data) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  let formData = new FormData();
  if (data) {
    formData.append("file", data.file);
    formData.append("type", data.type);
  }

  let headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      let response = await API.patch(
        `${UPDATE_INTERVIEW_LETTER}?examid=${examid}`,
        formData,
        {
          headers: headers,
        }
      );

      if (response) {
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getGeneralSlabReport = (examId, type = "general") => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_GENERAL_SLAB_REPORT}?examid=${examId}&type=${type}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        handleResponseMessage(response);
        let originalData = response.data;
        let sortedArray = originalData.slab.slice().sort(function (a, b) { return b.marks - a.marks; })
        originalData = { ...originalData, slab: sortedArray }

        dispatch({
          payload: originalData,
          type: SET_SLAB_REPORT_DATA,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: [],
        type: SET_SLAB_REPORT_DATA,
      });
      handleError(error);
    }
  };
};
export const cutOffLockUnlock = (
  selectedExam,
  status,
  lock,
  setUnlock,
  getObjectiveStatus
) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(
        `${GET_UNLOCK_CUTOFF}?examid=${selectedExam}&status=${status}&lock=${lock}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let successMessage =
        response && response.data ? response.data : response.message;
      toastr.success(successMessage);
      dispatch(getObjectiveStatus(selectedExam));
      setUnlock(true);
    } catch (error) {
      setUnlock(false);
      handleError(error);
    }
  };
};

export const getInterviewList = (advId, setPrintFlag) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_NEW_INTERVIEW_LIST}?advertisementid=${advId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_INTERVIEW_LIST,
        });
        setPrintFlag(false);
        handleResponseMessage(response);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: [],
        type: SET_INTERVIEW_LIST,
      });
      setPrintFlag(true);
      handleError(error);
    }
  };
};

export const getInterviewPostPrefList = (advId, setPrintFlag) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${INTERVIEW_POST_PREFERENCE}?advertisementid=${advId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_INTERVIEW_POST_PREFERENCE_LIST,
        });
        setPrintFlag(false);
        handleResponseMessage(response);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: [],
        type: SET_INTERVIEW_POST_PREFERENCE_LIST,
      });
      setPrintFlag(true);
      handleError(error);
    }
  };
};

export const getAllotmentChartByExamId = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${ALLOTMENT_CHART_REPORT}/${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_ALL_ALLOTMENT_CHART_DATA,
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAllDuplicateCodes = (examId, subjectId, setSaveButtonFlag) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_DUPLICATE_CODE_NO}/${examId}/${subjectId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALL_DUPLICATE_CODE_DATA,
        });
        if (response.data.message !==
          "No records found")
          setSaveButtonFlag(false);
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getRecommendationCutOff = (
  advertNo,
  examId,
  postcriteriaid,
  setPrintFlag
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_RECOMMENDATION_CUTOFF}/?advertisementid=${advertNo}&examid=${examId}&postcriteriaid=${postcriteriaid}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_RECOMMENDATION_CUTOFF_LIST,
        });
        if (response.data.message == "No records found") {
          // toastr.error(response.data.message)
          setPrintFlag(true);
        } else {
          setPrintFlag(false);
        }
        handleResponseMessage(response);
      }

      // dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAllUnApproveInterviewCriteriaListPagination = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_INTERVIEW_CRITERIA}/${pageNumber}/${rowPerPage}?entitytypes=interview_criteria`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_ALL_UNAPPROVED_INTERVIEW_CRITERIA_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_ALL_UNAPPROVED_INTERVIEW_CRITERIA_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_INTERVIEW_CRITERIA_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_ALL_UNAPPROVED_INTERVIEW_CRITERIA_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const approvalEntityInterviewCriteriaRequest = (
  requestData,
  setShowModal
) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(
        GET_INTERVIEW_CRITERIA_APPROVAL_ENTITY,
        requestData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setShowModal(false);
      dispatch(getAllUnApproveInterviewCriteriaListPagination(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const getAllUnApproveRecommendationCriteriaListPagination = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_RECOMMENDATION_CRITERIA}/${pageNumber}/${rowPerPage}?entitytypes=recommendation_criteria`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_ALL_UNAPPROVED_RECOMMENDATION_CRITERIA_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_ALL_UNAPPROVED_RECOMMENDATION_CRITERIA_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_RECOMMENDATION_CRITERIA_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_ALL_UNAPPROVED_RECOMMENDATION_CRITERIA_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const approvalEntityRecommendationCriteriaRequest = (
  requestData,
  setShowModal
) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(
        GET_RECOMMENDATION_CRITERIA_APPROVAL_ENTITY,
        requestData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setShowModal(false);
      dispatch(getAllUnApproveRecommendationCriteriaListPagination(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};


export const getRecommendationVigatvari = (
  advertNo,
  examId,
  postcriteriaid,
  setPrintFlag
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_RECOMMENDATION_VIGATVARI}/?advertisementid=${advertNo}&examid=${examId}&postcriteriaid=${postcriteriaid}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_RECOMMENDATION_VIGATVARI_DATA,
        });
        if (response.data.message == "No records found") {
          // toastr.error(response.data.message);
          setPrintFlag(true);
        }
        else {
          setPrintFlag(false)
        }
        handleResponseMessage(response);
      }

      // dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getInterviweScheduleByExamId = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_INTERVIEW_SCHEDULE}/${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_INTERVIEW_SCHEDULE,
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getRevisedInterviweSchedule = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_REVISED_INTERVIEW_SCHEDULE}/${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_REVISED_INTERVIEW_SCHEDULE,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getinterviewQualification = (examId, type) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session.jwtResponse && session.jwtResponse.token;

    try {
      let response;

      if (type === "interviewCriteria") {
        response = await API.get(
          `${GET_INTERVIEW_REPORTS_QUALIFIED}?examid=${examId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } else if (type === "meritlist") {
        response = await API.get(
          `${GET_RECOMMENDATION_CALCULATE_QUALIFIED}?examid=${examId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }

      if (response) {
        dispatch(getObjectiveStatus(examId));
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getrecommendationReports = (examId, type) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_REPORTS_QUALIFIED_CANDIDATE}?examid=${examId}&type=${type}
      `, {
        headers: { Authorization: `Bearer ${token}` },
      }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_INTERVIEW_QUALIFIED_CANDIDATE,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  }
};

export const getInterviewScheduleLetterByExamId = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_INTERVIEW_LETTER}/${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_INTERVIEW_LETTER,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};
export const getStageList = () => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session?.jwtResponse?.token;

    try {
      const response = await API.get(
        "/epms/api/v1/admin/stages",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({
        type: GET_STAGE_LIST,
        payload: response.data,
      });
    } catch (error) {
      handleError(error);
    }
  };
};
export const getRecommendationCriteriaView = (examId) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session?.jwtResponse?.token;

    try {
      const response = await API.get(
        `/epms/api/v1/admin/criteria?examid=${examId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({
        type: GET_RECOMMENDATION_CRITERIA_VIEW,
        payload: response.data,
      });
    } catch (error) {
      handleError(error);
    }
  };
};
export const qualificationMultipleCheck = (examid, stage) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session.jwtResponse.token;

    try {
      const response = await API.get(
        `/epms/api/v1/admin/qualificationmultiplecheck`,
        {
          params: {
            examid: examid,
            stage: stage,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Qualification Multiple Check Response:", response.data);

      return response.data;
    } catch (error) {
      console.log("Qualification Multiple Check Error:", error);
      throw error;
    }
  };
};